"use client";
import { useEffect } from "react";
import { useAtom } from "jotai";
import { isNewHeaderAtom } from "@/hooks/layoutAtoms";

const HeaderTypeSetter: React.FC<{ isNew: boolean }> = ({ isNew }) => {
  const [, setIsNew] = useAtom(isNewHeaderAtom);
  useEffect(() => {
    setIsNew(isNew);
  }, [isNew, setIsNew]);
  return null;
};

export default HeaderTypeSetter;